// TODO: replace with generated api-client service after client regeneration
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthControllerService } from 'src/app/api-client';
import { resolveApiBasePath } from './api-v2-base.util';
import type { PageTransactionDto, TransactionDto } from 'src/app/api-client';

export interface TransactionFilterOptions {
  query?: string;
  status?: TransactionDto.StatusEnum;
  type?: 'INVOICE_SCAN' | 'COUPON_BOUGHT' | 'MANUAL_TRANSACTION';
  loyaltyProgramId?: number;
  /** ISO date (yyyy-MM-dd), inclusive, interpreted as a Europe/Zagreb day by the backend. */
  dateFrom?: string;
  /** ISO date (yyyy-MM-dd), inclusive, interpreted as a Europe/Zagreb day by the backend. */
  dateTo?: string;
  direction?: string;
  sortBy?: string;
}

/**
 * Interim client for GET /api/transactions including the v2 filters
 * (loyaltyProgramId, dateFrom, dateTo) that the generated client does not know yet.
 * Mirrors the base-path resolution of the generated api-client services.
 */
@Injectable({ providedIn: 'root' })
export class TransactionFiltersV2Service {
  private readonly basePath: string;

  constructor(private http: HttpClient, apiConfig: AuthControllerService) {
    this.basePath = resolveApiBasePath(apiConfig);
  }

  /** Fetch the company's transactions page with all supported filters. */
  public getTransactions(
    page: number,
    size: number,
    opts: TransactionFilterOptions = {}
  ): Observable<PageTransactionDto> {
    let params = new HttpParams()
      .set('page', String(page))
      .set('pageSize', String(size));

    const optionalParams: Record<string, string | number | undefined> = {
      query: opts.query,
      status: opts.status,
      type: opts.type,
      loyaltyProgramId: opts.loyaltyProgramId,
      dateFrom: opts.dateFrom,
      dateTo: opts.dateTo,
      direction: opts.direction,
      sortBy: opts.sortBy,
    };
    Object.entries(optionalParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.set(key, String(value));
      }
    });

    return this.http.get<PageTransactionDto>(
      `${this.basePath}/api/transactions`,
      { params }
    );
  }
}
